import React from "react";
import PropTypes from "prop-types";

import styles from "./images.module.scss";

class Images extends React.Component {
  static propTypes = {
    items: PropTypes.arrayOf(
      PropTypes.shape({
        source: PropTypes.string,
        captionContent: PropTypes.object
      })
    ),
    onClick: PropTypes.func
  };
  imageRefs = [];
  state = {
    hiddenImagesCount: 1
  };
  componentDidMount() {
    this.compute();
    this.resizeEvent = window.addEventListener(`resize`, () => {
      this.compute();
    });
  }
  componentWillUnmount() {
    window.removeEventListener(`resize`, this.resizeEvent);
  }
  compute() {
    const root = this.rootRef;
    const more = this.moreRef;
    const rootWidth = root && root.offsetWidth;
    const widthOfImages =
      this.props.items && this.props.items.map(() => 248 /* 240 + 8*/);
    const moreWidth = more && more.offsetWidth;
    if (root && this.props.items) {
      const hiddenImagesCount =
        this.props.items.length -
        this.cutImages(widthOfImages, rootWidth, moreWidth).length;

      this.setState({
        hiddenImagesCount:
          hiddenImagesCount === this.props.items.length
            ? this.props.items.length - 1
            : hiddenImagesCount
      });
    }
  }
  cutImages(widthOfImages, rootWidth, moreWidth = 0) {
    let tmpCount = rootWidth - moreWidth;
    let tmpArray = [];
    for (let i = 0; i < widthOfImages.length; i++) {
      const imageWidth = widthOfImages[i];
      if (imageWidth > tmpCount) {
        break;
      } else {
        tmpCount -= imageWidth;
        tmpArray = [...tmpArray, imageWidth];
      }
    }
    return tmpArray;
  }
  render() {
    const {hiddenImagesCount} = this.state;
    const {items, onClick} = this.props;
    const visibleImagesCount = items.length - hiddenImagesCount;
    return (
      <div className={styles.root} ref={(rootRef) => (this.rootRef = rootRef)}>
        {items
          .map(({source}, index) => (
            <div
              key={source}
              style={{backgroundImage: `url(${source})`}}
              className={styles.image}
              onClick={onClick(index)}
            />
          ))
          .slice(0, visibleImagesCount)}
        {hiddenImagesCount ? (
          <div
            className={styles.more}
            ref={(ref) => {
              this.moreRef = ref;
            }}
            onClick={onClick(visibleImagesCount)}
          >
            +{hiddenImagesCount}
          </div>
        ) : null}
      </div>
    );
  }
}

export default Images;
